/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import useSWR from "swr";
import useSWRImmutable from "swr/immutable";

import { useAccountId } from "../account/account.hooks";
import { useApiConfig } from "../api-config";

import { getOptIn, updateOptIn } from "./opt-in.fetch";

interface HookRes {
	isLoading: boolean;
	error: any;
}

interface IsOptInHookRes extends HookRes {
	hasOptIn: boolean;
}
export const useIsOptIn = (): IsOptInHookRes => {
	const accountId = useAccountId();
	const { serverUrl } = useApiConfig();
	const shouldFetch = Boolean(accountId);

	const { data, error } = useSWR(shouldFetch ? [`optin-${accountId}`, serverUrl] : null, (_key, url) => getOptIn(url), {
		errorRetryCount: 0,
	});

	return {
		hasOptIn: data?.settingValue === true,
		isLoading: Boolean(!data && !error && shouldFetch),
		error,
	};
};

interface UpdateOptInHookRes extends HookRes {
	isOptInSuccess: boolean;
}
export const useUpdateOptIn = (execute: boolean): UpdateOptInHookRes => {
	const accountId = useAccountId();
	const { serverUrl } = useApiConfig();
	const shouldFetch = Boolean(execute && accountId);

	const { data, error } = useSWRImmutable(
		shouldFetch ? [`optin-update-${accountId}`, serverUrl] : null,
		(_key, url) => updateOptIn(url),
		{ errorRetryCount: 0 },
	);

	return {
		isOptInSuccess: data?.success === true,
		isLoading: Boolean(!data && !error && shouldFetch),
		error: error || data?.success === false,
	};
};
